export default "__VITE_ASSET__DxGjapy0__"